import { render, staticRenderFns } from "./FormSecondaryEventBlockSettings.vue?vue&type=template&id=37e62020"
import script from "./FormSecondaryEventBlockSettings.vue?vue&type=script&lang=js"
export * from "./FormSecondaryEventBlockSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports